import React from "react";
import { FaPlay } from "react-icons/fa";

import Button from "../../shared/Button";

import hero from "../../assets/image/hero.svg";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="hero-wrapper">
      <div className="hero-content">
        <h1 className="hero-title" >The Design Thinking superpowers</h1>
        <p className="hero-text">
          Tools, tutorials, design and innovation experts, all in one place! The
          most intuitive way to imagine your next user experience.
        </p>
        <div className="hero-buttons">
          <Button btn="Get started"/>
          <div className="hero-link">
              <FaPlay className="play-icon"/>
              <a href="#">Watch the Video</a>
              </div>
        </div>
      </div>
      <img src={hero} alt="hero" className="hero-img" />
    </div>
  );
};

export default Hero;
